<template>
    <div v-if="show">
        <div class="modal-backdrop fade show" @click="close"></div>
        <div class="modal fade show" tabindex="-1" role="dialog" style="display: block;" @click.self="close">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="far fa-barcode-read mr-1"></i>
                            Historique du numéro de série : <span class="ix-text-bold">{{ serialNumber }}</span>
                        </h5>
                        <button type="button" class="close" @click="close" aria-label="Fermer">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                    <div v-if="loading" class="text-center py-4">
                        <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
                        <p class="text-muted small mt-2 mb-0">Chargement de l'historique...</p>
                    </div>
                    <div v-else-if="error" class="text-center py-4">
                        <i class="far fa-exclamation-circle text-danger mb-2" style="font-size: 32px;"></i>
                        <p class="text-danger small mb-0">{{ error }}</p>
                    </div>
                    <div v-else-if="history.length === 0" class="text-center py-4">
                        <i class="far fa-info-circle text-muted mb-2" style="font-size: 32px;"></i>
                        <p class="text-muted small mb-0">Aucun mouvement enregistré pour ce numéro de série.</p>
                    </div>
                    <div v-else class="sn-history-timeline">
                        <div
                            v-for="(item, index) in history"
                            :key="index"
                            class="sn-history-item"
                            :class="typeClass(item.type)"
                        >
                            <div class="sn-history-dot">
                                <i class="far" :class="typeIcon(item.type)"></i>
                            </div>
                            <div class="sn-history-card">
                                <div class="sn-history-card-header">
                                    <span class="sn-history-label">{{ item.type_label }}</span>
                                    <span class="sn-history-date">{{ item.date }}</span>
                                </div>
                                <div class="sn-history-card-body">
                                    <a :href="item.movement_url" class="sn-history-ref">{{ item.movement_number }}</a>
                                    <template v-if="item.extra_label && item.extra_url">
                                        — <a :href="item.extra_url" class="sn-history-ref">{{ item.extra_label }}</a>
                                    </template>
                                    <div class="sn-history-meta">
                                        <span v-if="item.emplacement_origine && item.emplacement_destination" class="sn-history-emp">
                                            <i class="far fa-map-marker-alt mr-1"></i>{{ item.emplacement_origine }} → {{ item.emplacement_destination }}
                                        </span>
                                        <span v-else-if="item.emplacement_origine" class="sn-history-emp">
                                            <i class="far fa-map-marker-alt mr-1"></i>Depuis {{ item.emplacement_origine }}
                                        </span>
                                        <span v-else-if="item.emplacement_destination" class="sn-history-emp">
                                            <i class="far fa-map-marker-alt mr-1"></i>Vers {{ item.emplacement_destination }}
                                        </span>
                                        <span v-if="item.deal && item.deal_url" class="sn-history-deal">
                                            <i class="far fa-folder mr-1"></i><a :href="item.deal_url">{{ item.deal }}</a>
                                        </span>
                                        <span class="ix-state bordered" :class="item.state_color">{{ item.state_label }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
export default {
    name: 'article-serial-number-history-modal',
    props: {
        articleId: {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            show: false,
            loading: false,
            error: null,
            serialNumber: '',
            history: [],
        };
    },
    mounted() {
        window.addEventListener('keydown', this.handleEscape);
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleEscape);
    },
    methods: {
        open(serialNumber) {
            this.serialNumber = serialNumber;
            this.show = true;
            this.loading = true;
            this.error = null;
            this.history = [];
            this.fetchHistory();
        },
        close() {
            this.show = false;
        },
        handleEscape(e) {
            if (e.key === 'Escape' && this.show) {
                this.close();
            }
        },
        fetchHistory() {
            const url = `/stocks/articles/${this.articleId}/serial-numbers/history?sn=${encodeURIComponent(this.serialNumber)}`;

            fetch(url, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': document.head.querySelector("[name~=csrf-token][content]").content,
                },
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('HTTP ' + response.status);
                    }
                    return response.json();
                })
                .then(data => {
                    this.loading = false;
                    if (data.success) {
                        this.history = data.history;
                    } else {
                        this.error = data.message || 'Erreur lors du chargement.';
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.error = 'Erreur lors du chargement de l\'historique.';
                });
        },
        typeIcon(type) {
            if (type === 1) return 'fa-arrow-left';
            if (type === 3) return 'fa-exchange-alt';
            return 'fa-arrow-right';
        },
        typeClass(type) {
            if (type === 1) return 'sn-history-in';
            if (type === 3) return 'sn-history-intern';
            return 'sn-history-out';
        },
    },
};
</script>
